import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { supabase, ADMIN_EMAIL } from "../supabaseClient";

const BACKEND_URL = "https://alpha-apk-backend.onrender.com";

function AdminLogin() {
  const [code, setCode] = useState("");
  const [user, setUser] = useState(null);
  const [checking, setChecking] = useState(true);
  const navigate = useNavigate();

  useEffect(() => {
    const checkUser = async () => {
      const { data } = await supabase.auth.getUser();
      setUser(data?.user || null);
      setChecking(false);
    };

    checkUser();
  }, []);

  const loginWithGoogle = async () => {
    await supabase.auth.signInWithOAuth({
      provider: "google",
      options: {
        redirectTo: window.location.origin + "/admin",
      },
    });
  };

  const logout = async () => {
    await supabase.auth.signOut();
    localStorage.removeItem("alphaAdminAuth");
    setUser(null);
  };

  const login = async () => {
    if (!user || user.email !== ADMIN_EMAIL) {
      alert("Access denied. Only owner account can open admin.");
      return;
    }

    try {
      const res = await fetch(`${BACKEND_URL}/api/admin-auth`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ code }),
      });

      const data = await res.json();

      if (data.success) {
        localStorage.setItem("alphaAdminAuth", "true");
        navigate("/admin/dashboard");
      } else {
        alert("Wrong security code");
      }
    } catch (error) {
      console.log("LOGIN ERROR:", error);
      alert("Login failed");
    }
  };

  if (checking) {
    return <h2>Checking admin access...</h2>;
  }

  if (!user) {
    return (
      <div>
        <h2>Admin Login</h2>
        <p>Please login with owner Google account first.</p>
        <button onClick={loginWithGoogle}>Login with Google</button>
      </div>
    );
  }

  if (user.email !== ADMIN_EMAIL) {
    return (
      <div>
        <h2>Access Denied</h2>
        <p>This account is not allowed to access admin panel.</p>
        <p>{user.email}</p>
        <button onClick={logout}>Logout</button>
      </div>
    );
  }

  return (
    <div>
      <h2>Admin Login</h2>
      <p>Logged in as: {user.email}</p>

      <input
        value={code}
        onChange={(e) => setCode(e.target.value)}
        placeholder="Security Code"
      />

      <button onClick={login}>Login</button>
      <button onClick={logout}>Logout Google</button>
    </div>
  );
}

export default AdminLogin;